module.exports = __webpack_public_path__ + "img/galeria-captores-2.0cb1c95a.png";